import React, { useEffect, useMemo, useRef, useState } from 'react'
import { queryKeys } from './queries'
import useSearchDebounce from 'hooks/useSearchDebounce'
import useFilter from 'hooks/useFilter'
import { useQuery } from '@tanstack/react-query'
import Global from 'general/utils/Global'
import DraggableModal from '../DragableModal/DraggableModal'
import Utils from 'general/utils/Utils'
import useToken from 'hooks/useToken'
import CustomDataTable from 'general/components/CustomDataTable'
import { getColumns } from './columns'
import { useNavigate } from 'react-router-dom'
import ToastHelper from 'general/helpers/ToastHelper'

const FindDocumentModal = (props) => {
  const { token } = useToken()
  const modalRef = useRef(null)
  const { show, onHide, title, selectableRows, status } = props
  const navigate = useNavigate()
  const { debouncedSearch, setSearch } = useSearchDebounce('')
  const [clearSelected, setClearSelected] = useState(false)
  const [selectedDocuments, setselectedDocuments] = useState([])

  const [filters, setFilters] = useState(Global.gFiltersInvoiceList_findmodal)
  const [filter, setFilter] = useFilter(
    'documentErrAnnouce',
    'gFilterDocumentErrAnnouce',
  )
  const { data, isFetching, refetch } = useQuery({
    ...queryKeys.lists({
      ...filter,
      ...filters,
      status,
      notErrannouce: false,
      typeAd: props?.typeAd,
    }),
    enabled: show,
  })

  const columns = useMemo(() => {
    return getColumns()
  }, [])

  useEffect(() => {
    if (show) {
      refetch()
    }
  }, [show])

  const array_accounting_documentsId = (dataArray) =>
    dataArray?.map((item) => item.accounting_documentsId).filter(Boolean) || []

  return (
    <DraggableModal
      applyText={props?.onSave ? 'Đóng' : 'Đồng ý'}
      ref={modalRef}
      handleApplyChanges={() => {
        if (props?.onSave) {
          onHide()
        } else {
          if (selectedDocuments && selectedDocuments.length > 0) {
            navigate(
              '/hoa-don-dau-ra/chung-tu-tncn/xu-ly-chung-tu/thong-bao-sai-sot/' +
                array_accounting_documentsId(selectedDocuments),
            )
          } else {
            ToastHelper.showError('Vui lòng chọn chứng từ')
          }
        }
      }}
      title={title}
      hasApplyButton={() => {}}
      isOpen={show}
      onOpenChange={() => onHide()}
      width={'80%'}
      styles={{
        header: {
          borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
          margin: 0,
        },
        body: {
          padding: 0,
        },
        footer: {
          borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
        },
      }}
    >
      <div style={{ padding: '0px 10px' }}>
        <br></br>
        <div className="d-flex flex-row">
          <p className="mb-2 mr-8">{`Số lượng chứng từ: ${data?.total ?? 0}`}</p>
        </div>
        <CustomDataTable
          wrapperClassName="max-h-300px"
          columns={columns}
          dataSource={data?.rows}
          isLoading={isFetching}
          scrollY="300px"
          isSelectable={props?.onSave ? false : selectableRows}
          pagination={{
            currentPage: filters?.page,
            rowsPerPage: filters?.limit,
            total: data?.total,
            onChangePage: (page) => {
              setFilters({
                ...filters,
                page,
              })
            },
            onChangeRowsPerPage: (limit) => {
              setFilters({
                ...filters,
                limit,
                page: 1,
              })
            },
          }}
          selectedRows={{
            clearSelectedRows: clearSelected,
            handleSelectedRows: ({ selectedRows }) => {
              setselectedDocuments(selectedRows)
            },
            selectableRowSelected: (row) =>
              selectedDocuments?.some((item) => {
                return (
                  item.accounting_documentsId === row.accounting_documentsId
                )
              }),
          }}
          handleDoubleClickRow={(row) => {
            if (props.onSave) props.onSave(row)
          }}
          isClickable
        />
      </div>
    </DraggableModal>
  )
}

export default FindDocumentModal
